import { Autocomplete, Box, Stack, TextField, Typography } from "@mui/material";
import React from "react";
import { StringField } from "../ConfigFields/StringField";
import { EnumField } from "../ConfigFields/EnumField";
import { formatTitle } from "../utils";
import { ArrayObjectField } from "../ConfigFields/ArrayObjectField";
import { NumberField } from "../ConfigFields/NumberField";
import { Close } from "@mui/icons-material";
import { ColorsConstants } from "../../../../cssUtils/constants";

const SendEmailPreset = ({ schema, config, handleConfigChange }) => {
  return (
    <Stack spacing={3}>
      <StringField
        fieldKey={"subject"}
        schema={schema?.properties["subject"] || {}}
        value={config["subject"]}
        required={true}
        onChange={(val) => handleConfigChange("subject", val)}
      />

      <StringField
        fieldKey={"body"}
        schema={schema?.properties["body"] || {}}
        value={config["body"]}
        required={true}
        onChange={(val) => handleConfigChange("body", val)}
      />

      <Box>
        <Typography sx={{ fontWeight: "bold", mb: 2 }}>
          {formatTitle("admins")}
        </Typography>

        <Box sx={{ px: 1 }}>
          {config["recipients"]?.map((item, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                borderBottom: "1px solid #ddd",
                gap: 1,
                mb: 1.5,
                pb: 1.5,
              }}
            >
              <TextField
                label={formatTitle(`admin_${index + 1}`)}
                type="text"
                value={item ?? ""}
                onChange={(e) =>
                  handleConfigChange(
                    "recipients",
                    config["recipients"].map((r, i) =>
                      i === index ? e.target.value : r,
                    ),
                  )
                }
                size="small"
                fullWidth
              />

              <Box
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  const updated = config["recipients"].filter(
                    (_, i) => i !== index,
                  );
                  handleConfigChange("recipients", updated);
                }}
              >
                <Close />
              </Box>
            </Box>
          ))}

          <Box
            onClick={() => {
              handleConfigChange("recipients", [
                ...(config["recipients"] || []),
                "",
              ]);
            }}
            sx={{
              cursor: "pointer",
              color: ColorsConstants.primaryBlue100,
              fontWeight: "bold",
            }}
          >
            + Add
          </Box>
        </Box>
      </Box>
    </Stack>
  );
};

export default SendEmailPreset;
